export default function (state) {
  state.isLoading = false;
  state.isLoaded = true;
}
